import { useOdooAuth } from '@/lib/OdooAuthContext';
import RepDashboard from '@/components/dashboard/RepDashboard';
import ManagerDashboard from '@/components/dashboard/ManagerDashboard';

/**
 * Dashboard entry — picks the view based on the user's role in Odoo.
 *
 * The role is set per user in Odoo's user settings under
 * "تطبيق SellGo" (provided by the `sellgo_field_visits_v5` addon):
 *   - "مدير"  → ManagerDashboard
 *   - "مندوب" → RepDashboard
 *
 * No in-app toggle. The current role is displayed as a read-only badge
 * in the sidebar header (see AppLayout.jsx).
 */
export default function Dashboard() {
  const { odooSession } = useOdooAuth();
  // Supervisors get the monitoring (manager-style) dashboard, but the backend
  // scopes the data to the reps they oversee. Reps get the rep dashboard.
  const role = odooSession?.role;
  const showManagerView = role === 'manager' || role === 'supervisor';

  return showManagerView ? <ManagerDashboard /> : <RepDashboard />;
}
